import { TranslationObject } from '../i18n/translation';

const namespace = 'activity.student';

const translations: TranslationObject = {
  onskelisteTitle: {
    id: `${namespace}.onskelisteTitle`,
    nb: 'Ønskeliste for {emneTitle}',
    en: 'Wish list for {emneTitle}',
  },
  activitiesEmpty: {
    id: `${namespace}.activitiesEmpty`,
    nb: 'Her kommer du til å finne en oversikt over alle praksisaktiviteter for studieåret ditt.',
    en: 'Here you will find a list of all your work placements for the semester',
  },
  currentActivities: {
    id: `${namespace}.currentActivities`,
    nb: 'Din praksis',
    en: 'Your placements',
  },
  subject: { id: `${namespace}.subject`, nb: 'Emne', en: 'Subject' },
  status: { id: `${namespace}.status`, nb: 'Status', en: 'Status' },
  period: { id: `${namespace}.period`, nb: 'Periode', en: 'Period' },
  week: { id: `${namespace}.week`, nb: 'Uke', en: 'Week' },
  thisWeek: { id: `${namespace}.thisWeek`, nb: 'Denne uken', en: 'This week' },
  thisWeekToWeek: {
    id: `${namespace}.thisWeekToWeek`,
    nb: 'Denne uken t.o.m.',
    en: 'Starting this week out',
  },
  spring: { id: `${namespace}.spring`, nb: 'Vår', en: 'Spring' },
  autumn: { id: `${namespace}.autumn`, nb: 'Høst', en: 'Autumn' },
  action: { id: `${namespace}.action`, nb: 'Handling', en: 'Action' },
  showActivity: {
    id: `${namespace}.showActivity`,
    nb: 'Vis aktivitet',
    en: 'Show activity',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Her finner du oversikt over praksisaktiviteten',
    en: 'Work placement activity overview',
  },
  prioriterOnskelisteHjelp: {
    id: `${namespace}.prioriterOnskelisteHjelp`,
    nb: 'Prioriter ønskene dine ved å dra og slippe radene i ønskelisten',
    en: 'Change the rank of your wishes by dragging and dropping the rows in the wish list',
  },
  back: {
    id: `${namespace}.back`,
    nb: 'Til dashbord',
    en: 'To dashboard',
  },
  statusUndervisningsmeldt: {
    id: `${namespace}.status_notified`,
    nb: 'Undervisningsmeldt',
    en: 'Notified',
  },
  statusRegistrert: {
    id: `${namespace}.status_registered`,
    nb: 'Venter på fordeling av plass',
    en: 'Awaiting work placement',
  },
  statusOnskelisteTilgjengelig: {
    id: `${namespace}.status_onskelisteTilgjengelig`,
    nb: 'Ønskelisten er nå tilgjengelig',
    en: 'Wish list is available',
  },
  statusOnskelisteRegistrert: {
    id: `${namespace}.status_onskelisteRegistrert`,
    nb: 'Ønskelisten er registrert - endringer kan gjøres',
    en: 'Wish list has been submitted - changes can be made',
  },
  statusOnskelisteRegistrertIkkeTilgjengelig: {
    id: `${namespace}.status_onskelisteRegistrertIkkeTilgjengelig`,
    nb: 'Ønskelisten er lukket - venter på fordeling av plass',
    en: 'Wish list has been submitted - awaiting work placement',
  },
  statusPraksisplassMottatt: {
    id: `${namespace}.assigned`,
    nb: 'Mottatt praksisplass',
    en: 'Work placement received',
  },
  statusAktiv: {
    id: `${namespace}.status_aktiv`,
    nb: 'Aktiv',
    en: 'Active',
  },
  statusGjennomfoert: {
    id: `${namespace}.status_gjennomfoert`,
    nb: 'Gjennomført',
    en: 'Completed',
  },
  statusIkkePublisert: {
    id: `${namespace}.status_ikkePublisert`,
    nb: 'Fordelingen av plasser ferdigstilles',
    en: 'Work placement is being determined',
  },
  praksisplass: {
    id: `${namespace}.praksisplass`,
    nb: 'Praksisplass',
    en: 'Work placement',
  },
  praksisperiode: {
    id: `${namespace}.praksisperiode`,
    nb: 'Praksisperiode',
    en: 'Practice period',
  },
  aktivitetsemnenavn: {
    id: `${namespace}.aktivitet.emnenavn`,
    nb: 'Emnenavn',
    en: 'Subject name',
  },
  aktivitetsemnebeskrivelse: {
    id: `${namespace}.aktivitet.emnebeskrivelse`,
    nb: 'Emnebeskrivelse',
    en: 'Subject description',
  },
  emptyStateTitle: {
    id: `${namespace}.noPraksisYetText1`,
    nb: 'Du har ikke fått tildelt praksisplass ennå',
    en: 'You have not been assigned work placement yet',
  },
  emptyStateText: {
    id: `${namespace}.noPraksisYetText2`,
    nb: 'Du vil få en melding når denne praksisaktiviteten er klar.',
    en: 'You will receive a message when this work placement activity is ready.',
  },
  onskelisteDeadlineHeader: {
    id: `${namespace}.onskelisteDeadlineHeader`,
    nb: 'Ønskelisten er åpen til og med {deadline}',
    en: 'Deadline for setting up wish list is {deadline}',
  },
  onskelisteTilgjengeligInfo1: {
    id: `${namespace}.onskelisteTilgjengeligInfo1`,
    nb: 'Hurra! Du har nå muligheten til å oppgi dine ønsker for hvor du vil tilbringe din praksisperiode.',
    en: 'Hurray! You now have the option to set your preferred work placements for this period.',
  },
  onskelisteTilgjengeligInfo2: {
    id: `${namespace}.onskelisteTilgjengeligInfo2`,
    nb: ' Hvilken praksisplass du får tildelt avhenger av om det er mange eller få som har ønsket seg til de samme stedene, og hvor mange studenter som har krav på spesiell tildeling av praksisplass.',
    en: 'Your placement activity depends on how many or few set the same preferations, aswell as how many students have special grants for distribution.',
  },
  onskelisteTilgjengeligInfo3: {
    id: `${namespace}.onskelisteTilgjengeligInfo3`,
    nb: ' Vi håper å kunne oppfylle et av dine ønsker slik at du får en lærerik og spennende praksisperiode. Lykke til!',
    en: 'We hope to be able to fulfill your wishes so that you get an educational and exciting placement period. Good luck!',
  },
  setUpWishList: {
    id: `${namespace}.setUpWishList`,
    nb: 'Sett opp ønskelisten',
    en: 'Set up wish list',
  },
  onskelisteFrist: {
    id: `${namespace}.onskelisteFrist`,
    nb: 'Frist for ønskeliste',
    en: 'Wish list deadline',
  },
  fagpersoner: {
    id: `${namespace}.fagpersoner`,
    nb: 'Fagpersoner',
    en: 'Professionals',
  },
  medstudenter: {
    id: `${namespace}.medstudenter`,
    nb: 'Medstudenter',
    en: 'Students',
  },
  kontakt: {
    id: `${namespace}.kontakt`,
    nb: 'Kontakt',
    en: 'Contact',
  },
  rolle: {
    id: `${namespace}.rolle`,
    nb: 'Rolle',
    en: 'Role',
  },
  epost: {
    id: `${namespace}.epost`,
    nb: 'Epost',
    en: 'Email',
  },
  telefon: {
    id: `${namespace}.telefon`,
    nb: 'Telefon',
    en: 'Phone',
  },
  statusStudiestedKoordinator: {
    id: `${namespace}.statusStudiestedKoordinator`,
    nb: 'Koordinator ved studiested',
    en: 'Coordinator for institution',
  },
  statusStudiestedUnderviser: {
    id: `${namespace}.StudiestedUnderviser`,
    nb: 'Din underviser under praksisperioden',
    en: 'Teacher',
  },
  statusPraksisstedKoordinator: {
    id: `${namespace}.PraksisstedKoordinator`,
    nb: 'Koordinator ved praksissted',
    en: 'Practice place coordinator',
  },
  statusPraksisstedVeileder: {
    id: `${namespace}.PraksisstedVeileder`,
    nb: 'Din veileder under praksisperioden',
    en: 'Tutor',
  },
  wishListOpenUntil: {
    id: `${namespace}.wishListOpenUntil`,
    nb: 'Ønskelisten er åpen til og med {deadline}',
    en: 'The wish list is open until and including {deadline}',
  },
  wishListWasOpenUntil: {
    id: `${namespace}.wishListWasOpenUntil`,
    nb: 'Ønskelisten var åpen til og med {deadline}',
    en: 'The wish list was open until {deadline}',
  },
  changeWishList: {
    id: `${namespace}.changeWishList`,
    nb: 'Endre ønskelisten',
    en: 'Change wish list',
  },
  ranking: {
    id: `${namespace}.ranking`,
    nb: 'Prioritering',
    en: 'Ranking',
  },
  praksisstedTop: {
    id: `${namespace}.praksisstedTop`,
    nb: 'Praksissted',
    en: 'Work placement institution',
  },
  praksisstedLeaf: {
    id: `${namespace}.praksisstedLeaf`,
    nb: 'Plassering',
    en: 'Work placement department',
  },
  removeOnske: {
    id: `${namespace}.removeOnske`,
    nb: 'Slett ønske',
    en: 'Remove wish',
  },
  onskeSlettet: {
    id: `${namespace}.onskeSlettet`,
    nb: 'Ønske slettet',
    en: 'Wish removed',
  },
  onskeFlyttet: {
    id: `${namespace}.onskeFlyttet`,
    nb: 'Ønske flyttet',
    en: 'Wish moved',
  },
  pageTitle: {
    id: `${namespace}.pageTitle`,
    nb: 'Aktivitet {emneTitle}',
    en: 'Activity {emneTitle}',
  },
  wishList: {
    id: `${namespace}.wishList`,
    nb: 'Ønskeliste',
    en: 'Wish list',
  },
  wishListClosed: {
    id: `${namespace}.wishListClosed`,
    nb: 'Ønskelisten er stengt',
    en: 'The wish list has been closed for submissions',
  },
  fritekstTitle: {
    id: `${namespace}.fritekstTitle`,
    nb: 'Ekstra informasjon fra studiested',
    en: 'Additional information from the institution',
  },
  fritekstSubtitle: {
    id: `${namespace}.fritekstSubtitle`,
    nb: 'Informasjon om praksisaktiviteten sendt inn av koordinator ved studiestedet. Informasjonen er også sendt til praksisstedet.',
    en: 'Information regarding the practice activity shared by a coordinator at the institution. This information is also shared with the practice place.',
  },
};

export default translations;
